module.exports = __webpack_public_path__ + "static/media/ganapati.9e050e13.jpeg";